import {    Component,Input,ViewContainerRef,ViewChild,ComponentFactoryResolver, OnInit, ChangeDetectorRef, OnChanges, SimpleChanges, ComponentRef } from '@angular/core';
import { Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { DynamicLoaderService } from 'src/app/services/dynamic-loader.service';
import { FormulaServices } from 'src/app/services/formula.service';

@Component({
    selector: 'component-factory',
    templateUrl: './component-factory-view.component.html',
    styleUrls: ['./component-factory-view.component.scss'],
    standalone: false
})

export class ComponentFactoryComponent implements OnInit, OnChanges {

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private cd:ChangeDetectorRef, 
        private dls:DynamicLoaderService,
        private fs:FormulaServices){
            

        }
    
    ngOnChanges(changes: SimpleChanges): void {
        //if ( changes.inputs.currentValue != changes.inputs.previousValue){
            if (this.componentFactoryElement!= null ){
                this.componentFactoryElement.destroy();
                
                setTimeout(()=>{
                    const componentFactory =this.componentFactoryResolver.resolveComponentFactory(this.component);
                    this.componentFactoryElement = this.editContainer.createComponent(componentFactory);
                    this.componentFactoryElement.instance['data'] = changes.inputs.currentValue;
                    this.componentEditArray.push(this.componentFactoryElement);
                    this.cd.detectChanges();
                },100)
                
            }
        //}
        
    }
    currentComponent = null;
    componentEditArray = [];
    componentFactoryElement:ComponentRef<any> = null;
    @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) dynamicComponentContainer: ViewContainerRef;
    @ViewChild("editContainer", { read: ViewContainerRef })editContainer: ViewContainerRef;
    // component: Class for the component you want to create
    // inputs: An object with key/value pairs mapped to input name/input value
    @Input() component:any;
    @Input() inputs:any ;
    @Input() inputFormula:any;

    ngAfterViewInit(){
        if ( typeof(this.component) =='string' || this.component instanceof String){
                this.component = this.dls.getComponent(this.component as string);
        }
        
        if ( this.componentFactoryElement == null ){
            const componentFactory =
            this.componentFactoryResolver.resolveComponentFactory(
                this.component
            );
            
            if ( this.inputFormula != null){
                let variables:Variable[] = [];
                if ( this.inputs != null ){
                    this.fs.transformVariable(this.inputs,variables);
                }
                
                this.fs.executeFormula(this.inputFormula,variables).then(result=>this.createComponent(result,componentFactory));
            }else{
                this.createComponent(this.inputs, componentFactory);
            }
        
            
        }
        
    }

    createComponent(data,componentFactory){
        this.componentFactoryElement = this.editContainer.createComponent(componentFactory);
        this.componentFactoryElement.instance['data'] = data;
        this.componentEditArray.push(this.componentFactoryElement);
    }

    ngOnDestroy(){
        const component = this.componentEditArray.find(
            (component) => component.instance instanceof this.component
          );
          const componentIndex = this.componentEditArray.indexOf(component);
      
          if (componentIndex !== -1) {
            // Remove component from both view and array
            this.editContainer.remove(this.componentEditArray.indexOf(component));
            this.componentEditArray.splice(componentIndex, 1);
          }
    }

    ngOnInit(){
        
    }
    
    
    
}
    